// modifer: styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionCommentsStyle
import { section, title } from 'styles/jss/original/base';

const styles = {
  section,
  title: {
    ...title,
    marginBottom: '30px',
    textAlign: 'center'
  },
  footerButtons: {
    float: 'right'
  }
};

export default styles;
